// eslint-disable-next-line no-shadow
export const RestrictionTypes = [
  'Mint',
  'MintForSDD',
  'TradeFDEX',
  'TradeOther',
] as const
export type RestrictionType = (typeof RestrictionTypes)[number]
